module.exports = __webpack_public_path__ + "static/media/trash_icon.5430bdf7.svg";